import { create } from "zustand";

// Teams sharing model. Since the cutover every team runs it: a team's
// readers/editors decide, as the rules do, and Personal stays owner-only.
// The per-team flag (design_firms/{id}.sharingV2) only gated the rollout; the
// store and these helpers keep their API until PR6 removes them.
interface SharingV2State {
  flags: Record<string, boolean>;
  off: Record<string, true>;
  setFlag: (firmId: string, on: boolean) => void;
  markOff: (firmId: string) => void;
  reset: () => void;
}

export const useSharingV2Store = create<SharingV2State>((set) => ({
  flags: {},
  off: {},
  setFlag: (firmId, on) =>
    set((s) => (s.flags[firmId] === on ? s : { flags: { ...s.flags, [firmId]: on } })),
  markOff: (firmId) => set((s) => ({ off: { ...s.off, [firmId]: true } })),
  reset: () => set({ flags: {}, off: {} }),
}));

export const sharingV2Default = (): boolean => true;

export const sharingV2Enabled = (firmId: string | null | undefined): boolean => !!firmId;

// Whether the client can answer sharingV2Enabled for this firm yet: always.
export const sharingV2Known = (firmId: string | null | undefined): boolean => !!firmId;

export const setSharingV2Flag = (firmId: string, on: boolean) =>
  useSharingV2Store.getState().setFlag(firmId, on);

// The backend answers SHARING_OFF only before the env's sharing switch is on;
// the client no longer falls back to legacy for it.
export const markSharingOff = (firmId: string) =>
  useSharingV2Store.getState().markOff(firmId);

// The model no longer flips at runtime, so this never calls onFlip.
export const onSharingV2Flip = (
  _firmIdOf: () => string | null | undefined,
  _onFlip: () => void,
) => () => {};

// A team doc: its readers/editors decide, as the rules do.
export const sharingV2Doc = (doc: object | null | undefined): boolean => {
  const firm = (doc as any)?.design_firm_id;
  return !!doc && typeof firm === "string" && firm !== "";
};
